import { render, staticRenderFns } from "./ExerciseHistory.vue?vue&type=template&id=378dfff6"
import script from "./ExerciseHistory.vue?vue&type=script&lang=js"
export * from "./ExerciseHistory.vue?vue&type=script&lang=js"
import style0 from "./ExerciseHistory.vue?vue&type=style&index=0&id=378dfff6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports